export default __webpack_public_path__ + "b8ec121eae3be9c90414722e8d413784.png";